import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-custom-audio-player',
  templateUrl: './custom-audio-player.component.html',
  styleUrls: ['./custom-audio-player.component.scss'],
})
export class CustomAudioPlayerComponent  implements OnInit {
  @Input() audioUrl: string = '';
  @Input() savedCurrentTime: number = 0;
  @Output() audioEnded = new EventEmitter<{ currentTime: any }>();
  @Output() audioPaused = new EventEmitter<number>();
  @Output() audioWWillEnd = new EventEmitter<boolean>();
  @Input() reviewAllIsRequired: boolean = false;
//  audioUrl: string = '../assets/ICEONMYT.mp3';
  // audioUrl: string = 'https://samplelib.com/lib/preview/mp3/sample-3s.mp3';
  @ViewChild('audioElement', { static: false }) audioElement!: ElementRef<HTMLAudioElement>;

  isPlaying: boolean = false;
  isMuted: boolean = false;
  currentTime: number = 0;
  duration: number = 0;
  volume: number = 1;
  playbackRate: number = 1;
  playbackRates: number[] = [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2];
  waveformScale: number = 1;

  showSpeedMenu: boolean = false;
  playbackSpeed: number = 1;
  speedOptions: number[] = [0.5, 0.75, 1, 1.25, 1.5, 2];
  progress: number = 0;

  showVolumeBar: boolean = false;
  showControls: boolean = true;
  private hideTimeout?: any;
  hasSetInitialTime: boolean = false;
  private readonly SEEK_TOLERANCE = 0.05;


  ngOnInit(): void {
  }

  ngOnChanges(changes): void {
    // Detectar cuando cambia videoSrc
    if (changes['audioUrl'] && !changes['audioUrl'].firstChange) {
      this.resetPlayer();
    }

  }

  ngOnDestroy(): void {
    this.clearHideTimeout();
  }

  private resetPlayer(): void {
    // console.log("resetPlayer!")
    // Resetear el estado del reproductor
    this.isPlaying = false;
    this.showSpeedMenu = false;
    this.hasSetInitialTime = false;
    this.showControls = true;
    this.currentTime = 0;
    this.progress = 0;
    this.duration = 0;
    this.waveformScale = 1;

    // Resetear el video si ya existe
    if (this.audioElement?.nativeElement) {
      const audio = this.audioElement.nativeElement;
      audio.pause();
      audio.currentTime = 0;
      audio.load();
    }
    // console.log("fin resetPlayer!")
  }

  onLoadedMetadata(): void {
    if (this.audioElement) {
      this.duration = this.audioElement.nativeElement.duration;
      // console.log("onLoadedMetadata duration::", this.duration)
      // console.log("setInitialTime!")
      this.setInitialTime();
    }
  }

  onTimeUpdate(): void {
    const audio = this.audioElement.nativeElement;
    if (this.audioElement) {
      this.currentTime = this.audioElement.nativeElement.currentTime;
      this.progress = (audio.currentTime / audio.duration) * 100;
      this.updateWaveformScale();
      if(audio.currentTime > audio.duration-3){
        this.audioWWillEnd.emit(true);
      };
    }
  }

  private setInitialTime() {
    if (!this.hasSetInitialTime && this.savedCurrentTime > 0) {
      const audio = this.audioElement.nativeElement;

      // Asegurarse de que el audio esté listo
      if (audio.readyState >= 2) { // HAVE_CURRENT_DATA o superior
        audio.currentTime = this.savedCurrentTime;
        this.hasSetInitialTime = true;
        // console.log(`audio iniciado en: ${this.savedCurrentTime} segundos`);
      }
    }
  }

  private updateWaveformScale(): void {
    if (this.duration > 0) {
      const remainingTime = this.duration - this.currentTime;

      // Comienza a reducir las barras en los últimos 3 segundos
      // Escala de 1 (100%) a 0.3 (30% = ~20px de altura mínima)
      if (remainingTime <= 2) {
        this.waveformScale = 0.2 + (remainingTime / 3) * 0.7;
      } else {
        this.waveformScale = 1;
      }
    }
  }

  togglePlayPause(event: MouseEvent): void {
    event.stopPropagation();
    const audio = this.audioElement.nativeElement;
    if (this.isPlaying) {
      audio.pause();
      this.clearHideTimeout();
      this.showControls = true;
    } else {
      audio.play();
      this.hideControls();
      // Restaura la escala si se vuelve a reproducir después de terminar
      if (this.waveformScale === 0) {
        this.waveformScale = 1;
      }
    }
    this.isPlaying = !this.isPlaying;
  }

  toggleMute(): void {
    const audio = this.audioElement.nativeElement;
    this.isMuted = !this.isMuted;
    audio.muted = this.isMuted;
  }

  onVolumeChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.volume = parseFloat(input.value);
    const audio = this.audioElement.nativeElement;
    audio.volume = this.volume;
    this.isMuted = this.volume === 0;
    // if (this.volume > 0 && this.isMuted) {
    //   this.isMuted = false;
    //   this.audioElement.nativeElement.muted = false;
    // }
  }

  onProgressChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    const time = parseFloat(target.value);
    this.audioElement.nativeElement.currentTime = time;
    this.currentTime = time;
  }

  formatTime(seconds: number): string {
    if (isNaN(seconds) || !isFinite(seconds)) return '0:00';
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  }

  getVolumeIcon(): string {
    if (this.isMuted || this.volume === 0) return 'volume-mute';
    if (this.volume < 0.5) return 'volume-low';
    return 'volume-medium';
  }

  toggleSpeedMenu() {
    this.showSpeedMenu = !this.showSpeedMenu;
  }

  setPlaybackSpeed(speed: number) {
    this.playbackSpeed = speed;
    this.audioElement.nativeElement.playbackRate = speed;
    this.showSpeedMenu = false;
  }

  //   changePlaybackRate(): void {
  //   const currentIndex = this.playbackRates.indexOf(this.playbackRate);
  //   const nextIndex = (currentIndex + 1) % this.playbackRates.length;
  //   this.playbackRate = this.playbackRates[nextIndex];
  // }

  progressBarChange(event) {
    // console.log('ionChange emitted value::', event.detail.value);
    const time = parseFloat(event.detail.value || 0);
    const audio = this.audioElement.nativeElement;
     if(this.reviewAllIsRequired){
      // Disallow forward seeking: only allow seek if the requested time <= currentTime (rewind)
      if (time <= (this.currentTime + this.SEEK_TOLERANCE)) {
        audio.currentTime = time;
        this.currentTime = time;
      } else {
        // Block forward seek — restore slider to currentTime
        // This will sync slider bound [value]="currentTime" back to the actual time
        this.currentTime = audio.currentTime;
        if (!this.isPlaying) {
          audio.play();
          this.hideControls();
          if (this.waveformScale === 0) {
            this.waveformScale = 1;
          }
          this.isPlaying = !this.isPlaying;
        }
      }
    } else {
      audio.currentTime = time;
      this.currentTime = time;
    }
  }

  onRangeInput(event: any) {
    const time = parseFloat(event.detail?.value || 0);
    const audio = this.audioElement.nativeElement;
    if(this.reviewAllIsRequired) {
      if (time <= (this.currentTime + this.SEEK_TOLERANCE)) {
        // allow rewinding via drag
        this.currentTime = time;
      } else {
        // block forward dragging: keep slider at current time
        this.currentTime = audio.currentTime;
      }
    } else {
      this.currentTime = time;
    }
  }


  onPlayerAreaClick(e: Event) {
    e.stopPropagation();
    if (!this.isPlaying) {
      // si está pausado, tal vez no quieras ocultar/mostrar temporales: mantener visibles
      this.showControls = true;
      this.clearHideTimeout();
      return;
    }

    // si está reproduciendo, mostrar controles temporalmente
    this.showControlsTemporarily();
  }

  private showControlsTemporarily() {
    this.showControls = true;
    this.clearHideTimeout();
    this.hideTimeout = setTimeout(() => {
      this.showControls = false;
      this.hideTimeout = undefined;
    }, 2000); // 2 segundos
  }

  private hideControls() {
    this.clearHideTimeout();
    this.showControls = false;
  }

  private clearHideTimeout() {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = undefined;
    }
  }

  onAudioEnded(): void {
    const currentTime:any = this.audioElement.nativeElement.currentTime;
    this.isPlaying = false;
    this.audioEnded.emit(currentTime);
    this.isPlaying = false;
    this.waveformScale = 0.2;
  }

  onAudioPaused() {
    // console.log("onAudioPaused!")
    const currentTime = this.audioElement.nativeElement.currentTime;
    this.audioPaused.emit(currentTime);
  }

  public pauseAudio(): void {
    if (this.audioElement?.nativeElement) {
      const audio = this.audioElement.nativeElement;
      if (!audio.paused) {
        audio.pause();
      }
    }
  }
}
